import React, { useEffect, useState } from 'react';
import {
  Card, CardContent, Typography, Grid,
  Divider, Box
} from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import moment from 'moment';
import StatusAlert from './statusAlert';
import History from './history';
import TestManually from './testManually';
import { STATUS_CONFIG } from '../../constants'; // adjust path as needed
import './style.scss';
import SelectTimeModal from './selectTime';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const Cards = ({ data }) => {
  const [selectedTimes, setSelectedTimes] = useState({});

  useEffect(() => {
    if (data && data.length > 0) {
      const initialTimes = {};
      data.forEach(item => {
        const parsedTime = dayjs(item.time, 'HH:mm:ss', true);
        initialTimes[item.id] = parsedTime.isValid() ? parsedTime : dayjs('00:00:00', 'HH:mm:ss');
      });
      setSelectedTimes(initialTimes);
    }
  }, [data]);
  

  const handleTimeChange = (id, newTime) => {
    setSelectedTimes(prev => ({
      ...prev,
      [id]: newTime,
    }));
  };

  return (
    <Grid container spacing={2} className="main_content">
      {data && data?.length > 0 && data.map((item) => {
        const status = item.histories?.[0]?.status?.toLowerCase() || 'failed';
        const color = STATUS_CONFIG[status]?.flag;
        const timeForItem = selectedTimes[item.id];

        return (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            <Card
              style={{ padding: '14px' }}
              sx={{ borderRadius: 2, boxShadow: 3, position: 'relative', width: '400px' }}
            >
              <CardContent className="p-0">
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography fontWeight="bold" color="primary" className="test_case_title">
                    {item.role} | {item.category} | {item.subcategory}
                  </Typography>
                  <FiberManualRecordIcon sx={{ color, marginRight: '-5px' }} />
                </Box>

                <Divider sx={{ mt: 1, mb: '3px' }} />
                <Typography sx={{ color: '#1e1e43', fontSize: '13px', display: 'flex', alignItems: 'center' }}>
                  Daily runs at: {' '}
                  <span style={{ paddingLeft: '4px', fontWeight: 600 }}>
                    {timeForItem && dayjs(timeForItem, 'HH:mm:ss').isValid()
                      ? dayjs(timeForItem, 'HH:mm:ss').format('hh:mm A')
                      : "invalid time"}
                  </span>
                  <SelectTimeModal
                    id={item?.id}
                    selectedTime={timeForItem}
                    setSelectedTime={(newValue) => handleTimeChange(item.id, newValue)}
                  />
                </Typography>

                {item.histories?.length > 0 && (
                  <StatusAlert
                    status={item.histories[0].status}
                    message={item.histories[0].description}
                    reports={item.histories[0]}
                  />
                )}

                <Box mt={1.5} display="flex" justifyContent="space-between" alignItems="center">
                  <TestManually
                    diagnostic_id={item.id}
                    testCases={item.test_cases}
                    historyReports={item.history_reports}
                  />
                  <History historyData={item.histories} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};
export default Cards;
